import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@/components/ui/tabs.tsx";
import { GraduationTab } from "@/components/manage-personas/GraduationTab";
import { AllAgentsTab } from "@/components/manage-personas/AllAgentsTab.tsx";
import { Container } from "@/components/Container.tsx";
import { useTabUrlState } from "@/hooks/use-tab-url-state.tsx";
import { Input } from "@/components/ui/input";
import { useState } from "react";
import { useSolanaBalance } from "@/hooks/use-solana-balance";
import { SolanaIcon } from "@/components/icons/SolanaIcon";

const Tab = {
  agents: "agents",
  graduation: "graduation",
} as const;

const TABS = Object.values(Tab);

export function TokenAgentsPage() {
  const [tab, setTab] = useTabUrlState(TABS);
  const [searchQuery, setSearchQuery] = useState("");
  const solanaBalance = useSolanaBalance();

  return (
    <Container className="flex flex-col gap-4">
      <Tabs
        className="flex flex-col items-start"
        value={tab}
        onValueChange={setTab}
      >
        <div className="flex flex-col sm:flex-row gap-4 w-full ">
          <Input
            placeholder="Search"
            className="w-80"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            data-agents-page-tour="search-input"
            autoFocus
          />

          <TabsList className="mb-4 gap-4 bg-transparent [&>*]:!rounded-lg self-start w-full justify-start">
            <TabsTrigger
              className="text-white bg-transparent active:text-primary data-[state=active]:border-primary border"
              value="agents"
            >
              All agents
            </TabsTrigger>
            <TabsTrigger
              className="text-white bg-transparent active:text-primary data-[state=active]:border-primary border"
              value="graduation"
            >
              Graduation based
            </TabsTrigger>
          </TabsList>
          {solanaBalance !== null ? (
            <div className="flex items-center gap-2 mb-4 px-4 md:py-0 py-2 bg-black/40 rounded-lg w-fit">
              <SolanaIcon />
              <p>{solanaBalance.toFixed(4)}</p>
            </div>
          ) : undefined}
        </div>
        <TabsContent className="w-full" value="agents">
          <AllAgentsTab searchQuery={searchQuery} />
        </TabsContent>

        <TabsContent className="w-full" value="graduation">
          <GraduationTab searchQuery={searchQuery} />
        </TabsContent>
      </Tabs>
    </Container>
  );
}
